import { HttpClient, HttpErrorResponse, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PreguntaDTO, RelPreguntaTipoRespuestaDTO, ResponseService } from '../types/type';
import { catchError, retry, throwError, zip } from 'rxjs';
import { Utilerias } from '../helpers/Utilerias';

enum methods {
  GetChecklistsTipoRevision = 'GetChecklistsTipoRevision',
  GetTipoRevision = 'GetTipoRevision',
  UpdateStatusChecklist = 'UpdateStatusChecklist',
  SetPregunta = 'SetPregunta',
  UpdatePregunta = 'UpdatePregunta',
  GetRubrosChecklist = 'GetRubrosChecklist',
  GetCatalogoTipoRespuestas = 'GetCatalogoTipoRespuestas',
  SetRelPreguntaTipoRespuestas = 'SetRelPreguntaTipoRespuestas',
  GetBloquesChecklist = 'GetBloquesChecklist',
  DeleteBloque = 'DeleteBloque',
  GetChecklist = 'GetChecklist',
  GetConfiguracionChecklist = 'GetConfiguracionChecklist',
  UpdateEstatusDeleteChecklist = 'UpdateEstatusDeleteChecklist'
}

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionService {
  headers: HttpHeaders;
  URL: string

  constructor(private http: HttpClient) {
    this.URL = environment.urlService
    this.headers = new HttpHeaders();
    if (localStorage?.jwt) {
      this.headers = new HttpHeaders({
        'Authorization': localStorage.jwt
      })
    }
  }

  getChecklistTipoRevision(idTipoRevision: number) {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetChecklistsTipoRevision}?idTipoRevision=${idTipoRevision}`, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  getTipoRevision(idTipoRevision: number) {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetTipoRevision}?idTipoRevision=${idTipoRevision}`, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  updateStatusChecklist(IdChecklist: number) {
    const body = {
      c: {
        IdChecklist,
        IdEtapa: 3
      }
    }
    return this.http.post<ResponseService>(`${this.URL}${methods.UpdateStatusChecklist}`, body, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  postSetPregunta(pregunta: PreguntaDTO) {
    const body = {
      p: pregunta
    };
    return this.http.post<ResponseService>(`${this.URL}${methods.SetPregunta}`, body, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  updatePregunta(pregunta: PreguntaDTO) {
    const body = {
      p: pregunta
    };
    return this.http.post<ResponseService>(`${this.URL}${methods.UpdatePregunta}`, body, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getRubrosChecklist(idChecklist: number) {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetRubrosChecklist}?idChecklist=${idChecklist}`, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  getCatalogoTipoRespuestas() {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetCatalogoTipoRespuestas}`, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  loadInit(idChecklist: number) {
    return zip(
      this.getRubrosChecklist(idChecklist),
      this.getCatalogoTipoRespuestas()
    )
      .pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  setRelPreguntaTipoRespuestas(preguntas: RelPreguntaTipoRespuestaDTO[]) {
    const body = {
      r: preguntas
    }
    return this.http.post<ResponseService>(`${this.URL}${methods.SetRelPreguntaTipoRespuestas}`, body, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getBloquesChecklist(idChecklist: number) {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetBloquesChecklist}?idChecklist=${idChecklist}`, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  deleteBloque(idBloque: number) {
    return this.http.post<ResponseService>(`${this.URL}${methods.DeleteBloque}`, { idBloque }, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getChecklist(idChecklist: number) {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetChecklist}?idChecklist=${idChecklist}`, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getConfiguracionChecklist(idChecklist: number) {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetConfiguracionChecklist}?idChecklist=${idChecklist}`, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  loadInitChecklistDetalle(idChecklist: number) {
    return zip(
      this.getChecklist(idChecklist),
      this.getConfiguracionChecklist(idChecklist)
    )
      .pipe(
        catchError(this.handleError)
      );
  }

  updateEstatusDeleteChecklist(idChecklist: number) {
    return this.http.put<ResponseService>(`${this.URL}${methods.UpdateEstatusDeleteChecklist}`, { idChecklist }, {
      headers: this.headers
    })
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    console.log('Error en Usuarios Service' + error.message);
    Utilerias.alertClient('Error al hacer la petición', 'Intente de nuevo', 1);
    if (error.status === HttpStatusCode.Unauthorized) {
      Utilerias.closeSesion(this.http);
      return throwError(() => new Error('!Error Unauthorized, verifique sus credenciales!'))
    }
    return throwError(() => new Error('!Fuera de servicio, intente nuevamente!'))
  }
}
